import React, { useState } from 'react'
import '../styles/SentakuStyle.css'

const imageSel = './images/select.png';

function SentakuC() {

      const [isHovered, setIsHovered] = useState(false);

        return (

    <div
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    className='imageSelectionDiv'>

    { isHovered ? (
        <div className="isHoveredDiv">
        <img src={imageSel} id="img1" alt=""/>
        <a href='/projects' id='watashiSel'>プロジェクト</a>
        <img src={imageSel} id="img2" alt=""/>
        </div>
    ) : (<a href='/projects' id='watashiSel'>projects</a>
    )}
      </div>
  )
}

export default SentakuC
